"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlsConfigurationsByTenant = getUrlsConfigurationsByTenant;
var _cache = require("./internals/cache");
var _fetchConfiguration = require("./internals/fetchConfiguration");
var _loadConfiguration = require("./internals/loadConfiguration");
var _types = require("./types");
var _createConfigurationUrl = require("./utils/createConfigurationUrl");
const CACHE_KEY = 'URLS_CONFIGURATIONS_BY_TENANT';
async function getUrlsConfigurationsByTenant(environment, options) {
  const configuration = await (0, _loadConfiguration.loadConfiguration)((0, _cache.createCacheKey)(CACHE_KEY, environment), async () => (0, _fetchConfiguration.fetchConfiguration)((0, _createConfigurationUrl.createConfigurationUrl)(_types.ConfigurationType.Url, environment, 'tenants'), options?.configurationManagerOptions), {
    withoutCache: options?.withoutCache ?? false
  });
  return configuration;
}
